import { Logger } from '@/services/logger';
import { Domain, domainEnvSettingsMapping, getCountryDomainFromHost } from '../settings';
import { isDev } from '../environment';

export const USERCENTRICS_SCRIPT_ID = 'usercentrics-cmp';
export const USERCENTRICS_SCRIPT_URL = 'https://web.cmp.usercentrics.eu/ui/loader.js';
export const TCF_STUB_SCRIPT_URL = 'https://web.cmp.usercentrics.eu/tcf/stub.js';

const CMP_UC_TIMESTAMP_MS = 'CMP_UC_TIMESTAMP_MS';
const CMP_UC_CONTROLLER_ID = 'CMP_UC_CONTROLLER_ID';
const CMP_UC_USER_INTERACTION = 'CMP_UC_USER_INTERACTION';
const CMP_UC_SERVICES = 'CMP_UC_SERVICES';

export const getUsercentricsSettingsIdForDomain = () => {
  let domain = getCountryDomainFromHost();

  if (isDev()) {
    domain = Domain.de; // use DE settings for local development
  }

  if (!domain) {
    return;
  }

  const settingsId = domainEnvSettingsMapping[domain];

  if (!settingsId) {
    Logger.logError(
      `Missing USERCENTRICS_SETTINGS_ID variable for domain ${domain?.toUpperCase()}}`,
    );
  }

  return settingsId;
};

export const getTrackingSettingsId = () => {
  const domainSettingsId = getUsercentricsSettingsIdForDomain();

  return domainSettingsId;
};

export const getLocalTrackingDataTimestampMs = () => {
  return localStorage.getItem(CMP_UC_TIMESTAMP_MS);
};

export const getLocalControllerId = () => {
  return localStorage.getItem(CMP_UC_CONTROLLER_ID);
};

export const getLocalUserInteraction = () => {
  return localStorage.getItem(CMP_UC_USER_INTERACTION) === 'happened';
};

export const getTimestampInSeconds = (timestampInMs: number) => {
  return Math.floor(timestampInMs / 1000);
};

/**
 * Saves the timestamp in unix milliseconds.
 * It saves the current timestamp if the timestamp was not provided.
 */
export const saveChangeEventTimestampLocally = (timestamp = Date.now()) => {
  localStorage.setItem(CMP_UC_TIMESTAMP_MS, `${timestamp}`);
};

// NOTE: currently the controllerId is being overwritten on BE but this will be necessary if that changes
export const saveInitializationControllerIdLocally = (controllerId: string) => {
  localStorage.setItem(CMP_UC_CONTROLLER_ID, controllerId);
};

export const saveChangeEventUserInteractionLocally = () => {
  localStorage.setItem(CMP_UC_USER_INTERACTION, 'happened');
};

export const saveConsentServicesLocally = (data: Record<string, boolean>) => {
  localStorage.setItem(CMP_UC_SERVICES, JSON.stringify(data));
};

export const removeLocalCMPTrackingData = () => {
  localStorage.removeItem(CMP_UC_TIMESTAMP_MS);
  localStorage.removeItem(CMP_UC_CONTROLLER_ID);
  localStorage.removeItem(CMP_UC_USER_INTERACTION);
  localStorage.removeItem(CMP_UC_SERVICES);
};
